import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import envato from "assets/img/envato.png";

const Slider3 = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1100,
    arrows: false, // Removed arrows
    spaceBetween: 20,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section>
      <div className="relative gap-4">
        <Slider {...settings}>
          <div className="px-1">
           <p className="xl:text-2xl text-blue font-semibold opacity-effect">Innovative Process Technologies</p>
          </div>
          <div className="px-1">
          <p className="xl:text-2xl text-blue font-semibold opacity-effect">Innovative Process Technologies</p>
          </div>
          <div className="px-1">
          <p className="xl:text-2xl text-blue font-semibold opacity-effect">Innovative Process Technologies</p>
          </div>
          <div className="px-1">
          <p className="xl:text-2xl text-blue font-semibold opacity-effect">Innovative Process Technologies</p>
          </div>
          <div className="px-1">
          <p className="xl:text-2xl text-blue font-semibold opacity-effect">Innovative Process Technologies</p>
          </div>
          <div className="px-1">
          <p className="xl:text-2xl text-blue font-semibold opacity-effect">Innovative Process Technologies</p>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default Slider3;
